import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-info-marketplace-direct-sale-page',
  templateUrl: './info-marketplace-direct-sale-page.component.html',
  styleUrls: ['./info-marketplace-direct-sale-page.component.css'],


})
export class InfoMarketplaceDirectSalePageComponent {

  ngOnInit() {
    window.scrollTo(0, 0);
  }

}
